module.exports = __webpack_public_path__ + "media/images/advisor/img_1_2-a13708e0a0c86dd8cc2f82ab6534bb69.png";